// import GoodsModel from './utils/goods_model';
// import _get from 'lodash/get';

export default {
  // feed: (compProps) => {
  //   const params = {
  //     ...compProps.requestOptions,
  //     limit: compProps.limit,
  //   };
  //   const goodsModel = new GoodsModel(params);
  //   return [{ Path: '/fcgi/recommend/feedsqueryitem', Params: JSON.stringify(goodsModel.getRequestParams()) }];
  // },
  // feeds: (compProps) => {
  //   const { categoryList } = compProps;
  //   const currentIndex = 0;
  //   const currentSubIndex = 0;
  //   let defaultCategory;
  //   // 寻找默认的类目对象
  //   if (categoryList && categoryList.length && categoryList[currentIndex]) {
  //     const tab = categoryList[currentIndex];
  //     if (tab.children && tab.children.length && tab.children[currentSubIndex]) {
  //       // 当前选中tab为二级tab
  //       defaultCategory =  tab.children[currentSubIndex];
  //     } else {
  //       // 当前选中tab为一级tab
  //       defaultCategory =  tab;
  //     }
  //   } else {
  //     // 无tab
  //     defaultCategory =  compProps;
  //   }
  //   if (!defaultCategory.requestOptions.topSpuIDList) {
  //     defaultCategory.requestOptions.topSpuIDList = [];
  //   }
  //   const goodsModel = new GoodsModel({
  //     ...defaultCategory.requestOptions,
  //     limit: String(compProps.limit),
  //   });
  //   return [{ Path: '/fcgi/recommend/feedsqueryitem', Params: JSON.stringify(goodsModel.getRequestParams()) }];
  // },
  // 'coupon-list-v2': (compProps) => {
  //   const couponIds = compProps.ruleIDList;
  //   const coupons = couponIds.filter(couponId => couponId);
  //   return [
  //     { Path: '/fcgi/promotion/getpromotion', Params: JSON.stringify({
  //       RuleIdList: coupons,
  //     }) },
  //   ];
  // },
  // 'home-allowance-v2': (compProps) => {
  //   let config = {};
  //   let seq = 0;
  //   if (compProps && compProps.value) {
  //     config = JSON.parse(compProps.value);
  //   }
  //   const { requestOptions } = config;
  //   const { source, topSpuIDList = [], realCate = [], ...restOptions } = requestOptions;
  //   const fixedRequestOptions = {
  //     ...restOptions,
  //     topSpuIDList: topSpuIDList.join('|'),
  //     realCate: realCate.join('|'),
  //     channelID: '1',
  //   };
  //   return [{
  //     Path: '/fcgi/recommend/feedsqueryitem',
  //     Params: JSON.stringify({ Source: source || '37',
  //       RequestOption: fixedRequestOptions,
  //       Seq: seq += 1 }),
  //   }];
  // },
  // 'cube-list': (compProps) => {
  //   const { list } = compProps;
  //   const result = list.map((element) => {
  //     const requestOption = element && element.requestOptions;
  //     const source = _get(requestOption, 'source');
  //     const realCate = _get(requestOption, 'realCate') || [];
  //     const highPriorityActivity = _get(requestOption, 'highPriorityActivity') || null;
  //     const mediumPriorityActivity = _get(requestOption, 'mediumPriorityActivity') || null;
  //     const categroy = realCate.join('|') || null;
  //     const topSpuIDList = _get(requestOption, 'topSpuIDList') || [];
  //     const topSpuIDListStr = topSpuIDList.join('|');
  //     const params = {
  //       Source: source,
  //       requestOption: {
  //         limit: '1',
  //         channelID: '1',
  //         highPriorityActivity,
  //         mediumPriorityActivity,
  //         realCate: categroy,
  //         topSpuIDList: topSpuIDListStr,
  //       },
  //       Seq: 1,
  //     };
  //     return { Path: '/fcgi/recommend/feedsqueryitem', Params: JSON.stringify(params) };
  //   });
  //   return result;
  // },
};
